module.exports = __webpack_public_path__ + "img/compact.6ac93625.png";